import { createNanoEvents } from 'nanoevents'

import type { TrackEventParamsSchemaInput } from '@loc/server/interface/track/trackEventParams.common'
import type { ITrackCommonParams } from '../trackCommonParams'

export type TrackEventParams = TrackEventParamsSchemaInput & ITrackCommonParams

export interface IdentifyParams {
  userId: string
  email: string
}

interface Events {
  'track-event': (props: TrackEventParams) => void
  'identify': (props: IdentifyParams) => void
}

export const trackEmitter = createNanoEvents<Events>()
